import React from 'react';
import ReactDOM from 'react-dom';
import SearchMap from '../../../apps/searchMap';
import addTrackingToBackLink from '../../../apps/searchMap/helpers/addTrackingToBackLink';
import { fetchData } from '../../../helpers/base_data_fetcher';
import '../../../../sass/pages/list/offered/map/map_mobile.scss';

if (typeof module !== 'undefined') {
  if (module && module.hot) {
    module.hot.accept();
  }
}

const mountElement = document.querySelector('#search_map');
const params = new URLSearchParams(window.location.search);
const resultPageOffset = params.get('offset');
const isBrowsePage = params.get('browse');
const listViewBackLink = document.querySelector('.page-navigation__left-link');

if (resultPageOffset && resultPageOffset !== '0' && isBrowsePage === 'true') {
  editMapBackLink(listViewBackLink);
}

function editMapBackLink(backLink) {
  const backLinkHref = backLink.getAttribute('href');
  const pageCount = resultPageOffset / 10 + 1;
  const splitHref = backLinkHref.split('?');

  if (!/search_id/.test(backLinkHref)) {
    const urlParams = splitHref[1] ? `?${splitHref[1]}` : '';
    backLink.setAttribute(
      'href',
      `${splitHref[0]}/page${pageCount}${urlParams}`,
    );
  }
}

listViewBackLink.addEventListener('click', addTrackingToBackLink);

Promise.all([
  fetchData('page'),
  fetchData('site'),
  fetchData('config.features.apple_maps_mobile_search'),
]).then(([pageData, siteData, useAppleMaps]) => {
  const {
    apple_maps_token: appleMapsToken,
    search_data: initialSearchData,
    mode,
    editing,
    localisations,
  } = pageData;
  const props = {
    initialSearchData,
    mode,
    editing,
    useAppleMaps,
    appleMapsToken,
    siteData,
    localisations,
  };
  ReactDOM.render(<SearchMap {...props} />, mountElement);
});
